import { TranslationFunction } from 'i18next';
import { DEFAULT_LANGUAGE } from 'constants/locales';

export const translateToEnglish = (translateCb: TranslationFunction, key: string): string => {
    return translateCb(
        key,
        { lng: DEFAULT_LANGUAGE }
    );
};
